// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1043":"e4cb2d60","1853":"c7bd0a96","6414":"c7bd0a96","7730":"c7bd0a96"}[chunkId] + ".chunk.css";
};